/* eslint-disable camelcase */
import { Component, Ref, Prop } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class LinkedProducts extends ThemeComponent {

    @Prop tag!: string;
    @Prop selectedProductHandle!: string;
    @Prop apiToken!: string;

    async init() {
        try {
            await this.fetchLinkedProducts();
        } catch (error) {
            if (typeof error === "string") {
                throw Error(error);
            } else if (error instanceof Error) {
                throw Error(error.message);
            }
        }
    }

    async fetchLinkedProducts() {
        if (this.tag) {
            try {

                const headers = new Headers({
                    /* eslint-disable */
                    "Content-Type": "application/json",
                    "X-Shopify-Storefront-Access-Token": this.apiToken
                    /* eslint-enable */
                });

                const linkedProducts = fetch(
                    `/api/2023-04/graphql.json`,
                    {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify({
                            query: `
                                query GroupedProducts($query: String!) {
                                    products(first: 20, query: $query) {
                                        edges {
                                            node {
                                                id,
                                                title,
                                                onlineStoreUrl,
                                                handle,
                                                featuredImage {
                                                    url
                                                }
                                            }
                                        }
                                    }
                                }
                            `,
                            variables: {
                                query: `tag:${this.tag} AND available_for_sale:1`
                            }
                        })
                    }
                ).then(((res) => res.json()))
                    .then((products) => products.data.products.edges)
                    .catch((error) => {
                        if (typeof error === "string") {
                            throw Error(error);
                        } else if (error instanceof Error) {
                            throw Error(error.message);
                        }
                    });

                await linkedProducts.then((products: LinkedProductData) => {
                    for (const product of products) {
                        const markup = this.renderProduct(product);
                        this.innerHTML = this.innerHTML += markup;
                    }
                });


            } catch (error) {
                if (typeof error === "string") {
                    throw Error(error);
                } else if (error instanceof Error) {
                    throw Error(error.message);
                }
            }
        }
    }

    // TODO This URL needs to pull from the onlineStoreUrl value
    // once the site is public. It is set to null while the store
    // is password protected

    renderProduct(product: LinkedProduct) {
        return `
            <div
                class="
                    linked-products__product
                    ${ product.node.handle == this.selectedProductHandle ? 'linked-products__product-selected' : '' }
                "
            >
                <a href="/products/${product.node.handle}">
                    <img
                        class="linked-products__image"
                        src="${product.node.featuredImage.url}"
                    >
                </a>
            </div>
        `;
    }
}
